import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'
import { ReconciliationPage } from './_dashboard.inventory.reconciliation'

export const Route = createFileRoute('/_dashboard/inventory/reconciliation/$item')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: ReconciliationItemPage,
})

function ReconciliationItemPage() {
  const { item } = Route.useParams()
  return <ReconciliationPage selectedId={item} />
}
